import React, {memo, useState} from 'react'
import classnames from 'classnames'
import ReactTimeAgo from "react-time-ago"
import {Badge, Spinner} from 'reactstrap'
import { useSelector } from 'react-redux'


import Avatar from '@components/avatar'
import { useSkin } from '@hooks/useSkin'
import useJwt from "../../auth/jwt/useJwt"
import {convertUTCToLocal} from "../../utility/Utils"


const NotificationItem = memo(({ item, toast = false }) => {

    const { skin } = useSkin()
    const userData = useSelector(state => state.auth?.user)
    const [isLoading, setIsLoading] = useState(false)

    const link = () => {
        if (item.url) return `${item.url}`
        if (item.whoLikesId) return `/user/${userData.user.username}?FeedId=${item.feedId}`
        if (item.newFollowerId) return `/user/${item.newFollowerId}`
        if (item.couponTipsterId) return `/user/${item.couponTipsterId}?CouponId=${item.couponId}`
        if (item.whoPaidUserName) return `/user/${item.whoPaidUserName}`
        if (item.mentionedUserUserName) return `/user/${item.authorPostUserName}?FeedId=${item.feedId}`
        if (item.whoCommentedUserName) return `/user/${item.authorPostUserName}?FeedId=${item.feedId}`
        if (item.whoDonateUserName) return `/user/tipster-settings`
        if (item.type === 'coupon not settled') return `/user/${item.username}?CouponId=${item.couponId}`
        if (item.redirectionType === 'coupon') return `/l/${item.redirectionId}`
    }
    const linkURL = link()

    const onRead = () => {
        if (!item.readAtFormatted) {
            setIsLoading(true)
            useJwt.setAsReadNotification(item.id).then(() => {
                setIsLoading(false)
                window.location = linkURL
            }).catch(() => {
                window.location = linkURL
            })
        } else {
            window.location = linkURL
        }
    }

    const date = convertUTCToLocal(item.dateTimeFormatted)

    const avatar = item.avatar ?? item.whoLikesAvatar ?? item.whoDonateAvatar ?? item.tipsterAvatar ?? item.newFollowerAvatar ?? item.whoPaidAvatar ?? item.mentionedUserAvatar ?? item.whoCommentedAvatar ?? "/icons/apple-touch-icon.png"
    const layout = (skin === 'dark' && !toast) ? 'text-white' : 'text-black'


    return (
        <a className='d-flex' onClick={onRead}>
            <div
                className={classnames('list-item d-flex', {
                    'align-items-start': !item.switch,
                    'align-items-center': item.switch
                })}
            >
                <>
                    <div className='me-1'>
                        <Avatar img={avatar} imgHeight='40' imgWidth='40' />
                    </div>
                    <div className='flex-grow-1'>
                        <div className={`mb-0 ${layout}`} dangerouslySetInnerHTML={{ __html: item.description ?? item.type }}></div>
                        <small><ReactTimeAgo date={date} /></small>
                    </div>
                    <div className="flex-shrink-0 dropdown-notifications-actions">
                        <span className="dropdown-notifications-read">
                            {!item.readAtFormatted && !isLoading && (<Badge pill color='primary'> </Badge>)}
                            { isLoading ? <Spinner size={'sm'} /> : null }
                        </span><br />
                    </div>
                </>
            </div>
        </a>
    )
})

export default NotificationItem
